// Os períodos se sobrepõem: cada registro deve aparecer apenas uma vez no resumo.
export function consolidarDemandas(kanban = {}) {
	const periodos = ['demandaSemana', 'demandaProxima', 'demanda30', 'demandaDemais', 'demandaAtrasada'];
	const atividades = new Map();
	const tarefas = new Map();

	periodos.forEach(periodo => {
		const demanda = kanban[periodo] || {};
		(demanda.listaAtividade || []).forEach(atividade => {
			atividades.set(String(atividade.idatividade), atividade);
		});
		(demanda.listaTarefa || []).forEach(tarefa => {
			tarefas.set(String(tarefa.idtarefa), tarefa);
		});
	});

	return {
		listaAtividade: Array.from(atividades.values()),
		listaTarefa: Array.from(tarefas.values()),
	};
}